// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"203":"b7bb31b4","233":"776d5292"}[chunkId] + ".chunk.css";
};